import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {greenColors} from '../../../../../../layouts/theme/designSystem';
import {calculateDaysLeft} from '../../../../../../utils/dateUtils/calculateDaysUntilDate';
import {Survey} from '../../types/SurveyTypes';

interface SurveyPaperHeaderProps {
  survey: Survey | undefined;
  state: string | null;
}

export const SurveyPaperHeader = ({survey, state}: SurveyPaperHeaderProps) => {
  const {t} = useTranslation();

  const renderSurveyStateDetails = () => {
    let daysLeft;
    switch (state) {
      case 'current':
        return (
          <Grid container flexDirection='column' gap={1} alignItems='flex-start'>
            <Typography variant='h3' sx={{color: greenColors[700]}}>
              {t('companySurveys.details.title')}
            </Typography>
          </Grid>
        );

      case 'upcoming':
        daysLeft = calculateDaysLeft(survey);
        return (
          daysLeft !== null &&
          daysLeft >= 0 && (
            <Typography variant='body1'>
              {t('companySurveys.details.due', {
                daysLeft: daysLeft,
              })}
            </Typography>
          )
        );

      default:
        return null;
    }
  };

  return (
    <Grid container gap={{sm: 1}} marginBottom={1}>
      {renderSurveyStateDetails()}
    </Grid>
  );
};
